import { Component, OnInit, ViewChild } from '@angular/core';
import { EditbaseComponent } from '../../editbase.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationNodeRuleService } from 'src/app/services/navigation/navigation-node-rule.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';
import { NavigationNodeService } from 'src/app/services/navigation/navigation-node.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-navigation-node-form',
  templateUrl: './navigation-node-form.component.html',
  styleUrls: ['./navigation-node-form.component.less']
})
export class NavigationNodeFormComponent extends EditbaseComponent implements OnInit {

  @ViewChild('myForm') myForm!: NgForm;

  model:any = {
    ContextName:'left-menu',
    Type:1,
    Url:"",
    Provider:"Semantika.WebGalis.Navigation.FormNavigationProvider",
    User:{
    },
    GroupsModel:{

    }
  };

  rules:any={};

  activetab :string = "basic-info";

  constructor(private activatedRoute: ActivatedRoute, private router:Router, public navigationNodeService: NavigationNodeService, public navigationNodeRuleService:NavigationNodeRuleService, public messageService:MessageService, 
    public submenuService:SubmenuService, public translate: TranslateService) { 

      super();
    }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.params.id;

    if(id>0)
    {
      this.messageService.showLoading();
      this.navigationNodeService.loadById(id).subscribe((data:any) => {
        this.model = data;
        this.messageService.hideLoading();
      });
    }

    this.navigationNodeRuleService.loadPage(1, 999,"").subscribe(
      (data:any)=>{
        this.rules = data;
      }
    );
  }

  setActiveTab(tabName:string){
    this.activetab  = tabName;
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordDetails("/navigation/nodes", this);  
  }

  save() {

    if (this.myForm != null) {
      this.myForm.form.markAsTouched();
    }

    if (!this.myForm.invalid) {

    this.messageService.showLoading();
    this.navigationNodeService.save(this.model).subscribe(
      (data:any) => {

        this.model = data;
        this.messageService.hideLoading();
        this.messageService.showMessage("Data saved successfuly.", "success");

      },
    
      err =>{
        this.messageService.hideLoading();
        this.messageService.showMessage("Error:"+err, "error");
      });
    }else{
      this.messageService.showMessage("Vnesite zahtevana polja...", "error");
    }
  }

  delete() {
    this.messageService.showLoading();
    this.navigationNodeService.delete(this.model).subscribe((data:any) => {
      this.messageService.hideLoading();
      this.messageService.showMessage("Data saved successfuly.", "success");
      this.router.navigate(['navigation/nodes']);
    });
  }
}